<template>
  <div>
    <section class="page_box">
      <img :src="$utils.formatImgUrl('aiBanner.png')" alt="" />
    </section>
    <section id="bigBox">
      <div class="apply_course_box module_box">
        <h1 class="main_title">课程申请</h1>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-position="left"
          class="sub_module_box"
        >
          <div class="form-row">
            <div class="form-col">
              <el-form-item label="您的姓名" prop="name">
                <el-input v-model="ruleForm.name"></el-input>
              </el-form-item>
              <el-form-item label="公司名称" prop="companyName">
                <el-input v-model="ruleForm.companyName"></el-input>
              </el-form-item>
              <el-form-item label="联系电话" prop="phone">
                <el-input v-model="ruleForm.phone"></el-input>
              </el-form-item>
            </div>
            <div class="form-col">
              <el-form-item label="您的职务" prop="position">
                <el-input v-model="ruleForm.position"></el-input>
              </el-form-item>
              <el-form-item label="营收规模" prop="revenueScale">
                <el-select
                  v-model="ruleForm.revenueScale"
                  placeholder="请选择营收规模"
                >
                  <el-option label="500万以下" value="money1"></el-option>
                  <el-option label="500万~1000万" value="money2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="您的需求">
                <el-input v-model="ruleForm.demand"></el-input>
              </el-form-item>
            </div>
          </div>

          <el-form-item>
            <el-button @click="submitForm('ruleForm')">提交申请</el-button>
          </el-form-item>
        </el-form>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "ApplyCourse",
  components: {},
  data() {
    return {
      navTop: 0,
      navFixed: false,
      activeNav: 0,
      isScrolling: false,
      ruleForm: {
        name: "",
        position: "",
        companyName: "",
        revenueScale: "",
        demand: "",
      },
      rules: {
        name: [{ required: true, message: "请输入您的姓名", trigger: "blur" }],
        position: [
          { required: true, message: "请输入您的职务", trigger: "blur" },
        ],
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        phone: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
        revenueScale: [
          { required: true, message: "请选择营收规模", trigger: "change" },
        ],
      },
    };
  },
  created() {},
  mounted() {
    // 页面加载时强制显示导航栏
    const myNav = document.querySelector(".my_nav");
    if (myNav) {
      myNav.style.opacity = "1";
      myNav.style.transform = "translateY(0)";
      myNav.style.transition = "all 0.3s ease";
    }

    // 添加滚动事件监听
    window.addEventListener("scroll", this.handleScroll);

    // 获取page_nav元素的初始位置，确保DOM完全渲染后再获取
    setTimeout(() => {
      const navElement = document.querySelector(".page_nav");
      if (navElement) {
        this.navTop = navElement.offsetTop;
        // 页面刷新后检查滚动位置，更新导航栏状态
        this.handleScroll();
      }
    }, 100);
  },
  beforeDestroy() {
    // 移除滚动事件监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      // 获取滚动位置
      const scrollTop = window.scrollY;

      // 只有当navTop被正确设置后才进行导航栏状态判断
      if (this.navTop > 0) {
        // 处理page_nav固定定位
        if (scrollTop >= this.navTop - 90) {
          // 90是顶部导航栏的高度
          this.navFixed = true;
        } else {
          this.navFixed = false;
        }

        // 处理顶部导航栏显示/隐藏
        const myNav = document.querySelector(".my_nav");
        if (myNav) {
          if (this.navFixed) {
            myNav.style.opacity = "0";
            myNav.style.transform = "translateY(-100%)";
            myNav.style.transition = "all 0.3s ease";
          } else {
            myNav.style.opacity = "1";
            myNav.style.transform = "translateY(0)";
            myNav.style.transition = "all 0.3s ease";
          }
        }
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.ruleForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.apply_course_box {
  width: 100%;
  padding: 0 8%;
  box-sizing: border-box;
  margin: 100px auto;
}

.form-row {
  display: flex;
  justify-content: space-evenly;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0;
  }
}

.form-col {
  .el-form-item {
    margin-bottom: 50px;
    display: flex;
    align-items: center;

    ::v-deep .el-form-item__label {
      width: 100px;
      text-align: right;
      padding-right: 12px;
    }

    ::v-deep .el-form-item__content {
      flex: 0 0 300px;
    }
  }

  .el-input,
  .el-select {
    width: 100%;
  }
}
.el-button {
  width: 12rem;
  height: 3rem;
  font-size: 1.25rem;
  font-weight: 400;
  border-radius: 50px;
  background: linear-gradient(
    90deg,
    rgba(156, 179, 255, 1) 0%,
    rgba(2, 181, 232, 1) 100%
  );
  color: rgba(255, 255, 255, 1);
}
</style>
